import { loadData } from '@/lib/requests/loadData'
import { WithAbortRequestConfig } from '@/lib/requests/types'
import { City } from '@/types/location'

export async function searchSites({ search, signal }: { search: string } & WithAbortRequestConfig): Promise<City[]> {
	const lowerSearch = search.toLocaleLowerCase().trim()
	if (!lowerSearch) {
		return []
	}

	try {
		const { data } = await loadData<City[]>({ resourcePath: 'sites', params: { search: lowerSearch }, signal })
		return data
	} catch (e) {
		console.error(e)
		return []
	}
}

export function filterEmptyCities(cities: City[]): City[] {
	return cities.filter((city) => city.airports.length || city.offices.length || city.stations.length)
}
